import { en } from './langs/en'
import { it } from './langs/it'

export const messages = {
  en: en,
  it: it
}